<script>
  import * as restfulService from '../../../services/restfulService'

  import helpers from '@mixins/helper'

  import {required} from 'vuelidate/lib/validators'

  import NavigationButtons from './NavigationButtons'

  import {toArray} from 'lodash'

  import bus from '@utils/bus'

  export default {
    mixins: [helpers],
    components: {NavigationButtons},
    name: 'dados-matricula',
    props: {
      dados: {
        required: true,
        type: Object,
        default: () => ({})
      },
      etapaAtiva: {
        type: Number,
        default: 0
      },
      proximaEtapa: {
        type: Boolean,
        default: false
      },
      desabilita: {
        type: Object,
        default: () => ({})
      },
      textoJanela: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        carregandoDados: true,
        dependencias: {
          contratos: []
        },
        mostraHelp: false,
        titulo: '',
        ementa: '',
        turno: '',
        turma_virtual: ''
      }
    },
    computed: {
      dadosMatricula: {
        get () {
          return this.dados
        },
        set (value) {
          this.$emit('update:dados', value)
        }
      },
      contratoSelecionado () {
        const contrato = this.dependencias.contratos.find(item => item.ref_curriculo === this.dadosMatricula.matricula.ref_curriculo)
        // if (contrato.intencaoMatricula) {
        //   this.$emit('update:textoJanela', 'Intenção de Matrícula On-line')
        // } else {
        //   this.$emit('update:textoJanela', 'Pré-Matrícula On-line')
        // }
        this.$emit('update:textoJanela', 'Pré-Matrícula On-line')
        if (contrato) {
          return contrato
        }
        return null
      }
    },
    validations: {
      dadosMatricula: {
        matricula: {
          ref_curriculo: {required},
          ref_disciplina_cpp: {required}
        }
      }
    },
    watch: {
      etapaAtiva (value) {
        if (value === 2) {
          this.carregarDadosMatricula()
        }
      },
      'dados.matricula.ref_curriculo' (value) {
        this.dados.matricula.ref_disciplina_cpp = ''
        if (value) {
          const contrato = this.dependencias.contratos.find(item => item.ref_curriculo === value)
          this.dados.matricula.ref_contrato = contrato.ref_contrato
          this.dados.matricula.contrato.descricao = contrato.descricao
          this.dados.matricula.contrato.disciplinas = toArray(contrato.modulo.disciplinas)
          this.dados.matricula.modulo = contrato.modulo.modulo
          this.dados.matricula.descricao = contrato.modulo.descricao
        }
      },
      'dados.matricula.ref_disciplina_cpp' (value) {
        this.dados.matricula.contrato.cpp = this.contratoSelecionado.cpps.find(item => item.id === value)
      }
    },
    methods: {
      carregarDadosMatricula () {
        bus.$emit('show-loader')
        restfulService.get('matricula-online', 'academico')
          .then(response => {
            if (response.length > 0) {
              this.dependencias.contratos = [...response]
              if (this.dadosMatricula.matricula.ref_curriculo === '') {
                this.dadosMatricula.matricula.ref_curriculo = this.dependencias.contratos[0].ref_curriculo
                // if (this.dependencias.contratos[0].intencaoMatricula) {
                //   this.$emit('update:textoJanela', 'Intenção de Matrícula On-line')
                // } else {
                //   this.$emit('update:textoJanela', 'Pré-Matrícula On-line')
                // }
                this.$emit('update:textoJanela', 'Pré-Matrícula On-line')
              }
            }
            this.carregandoDados = false
          })
          .catch(e => {
            console.log(e)
          })
        bus.$emit('hide-loader')
      },
      salvarDados () {
        this.desabilita.aba2 = true
        this.desabilita.aba3 = false
        this.$emit('update:desabilita', this.desabilita)
        this.$emit('update:etapaAtiva', (this.etapaAtiva + 1))
      },
      voltar () {
        this.desabilita.aba1 = false
        this.desabilita.aba2 = true
        this.$emit('update:textoJanela', 'Atualize seus dados')
        this.$emit('update:etapaAtiva', (this.etapaAtiva - 1))
        this.$emit('update:desabilita', this.desabilita)
      },
      help (titulo, ementa, turno = null) {
        this.mostraHelp = false
        this.titulo = titulo
        this.ementa = ementa
        this.turno = turno
        this.mostraHelp = true
      },
      temCPP () {
        return (this.contratoSelecionado && this.contratoSelecionado.cpps.length)
      }
    }
  }
</script>

<template>
    <v-container fluid grid-list-md :pa-0="$vuetify.breakpoint.xsOnly" v-if="!carregandoDados">

        <v-dialog
          v-model="mostraHelp"
          scrollable
          persistent
          :width="$vuetify.breakpoint.xsOnly ? '98%' : '40%'"
        >
         <v-card>
           <v-card-title class="primary white--text">
             <span class="title-ementa">{{titulo}} <span v-if="turno">({{turno}})</span></span>
            </v-card-title>
            <v-card-text style="text-align: justify; height: 300px;">
              <span class="ementa">&nbsp;&nbsp;&nbsp;&nbsp;{{ementa}}</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="mostraHelp = false">
                Ok, entendi!
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-layout row wrap>
            <v-flex sm12 :md6="temCPP()" :lg6="temCPP()">
                <v-card flat color="grey lighten-4" mx-0>
                    <v-card-text class="pa-1">
                        <h4 class="title">Qual curso deseja se matricular?</h4>
                        <template v-if="dependencias.contratos.length">

                          <v-radio-group v-model="dadosMatricula.matricula.ref_curriculo" hide-details>

                              <v-radio v-for="(contrato, index) in dependencias.contratos"
                                      :key="index"
                                      color="secondary"
                                      :value="contrato.ref_curriculo">
                                      <div slot="label">{{contrato.descricao}}<v-chip>{{contrato.cidade}} - {{contrato.turno}}</v-chip></div>
                              </v-radio>

                          </v-radio-group>

                        </template>
                        <template v-else>
                          Nenhum currículo disponível para matrícula.
                        </template>

                        <v-divider class="mt-4 mb-4"></v-divider>
                        <div>
                            <h4 class="title mb-3">Abaixo estão as disciplinas que você vai cursar neste semestre</h4>
                            <template v-if="contratoSelecionado">
                                <template v-if="contratoSelecionado.modulo.disciplinas">
                                    <h4 class="subheading mb-3" v-if="contratoSelecionado.modulo.descricao">{{contratoSelecionado.modulo.descricao}}</h4>
                                    <div v-for="(disciplina) in contratoSelecionado.modulo.disciplinas"
                                    :key="disciplina.id"
                                    @click="help(disciplina.descricao, disciplina.ementa, disciplina.turno)"
                                    color="primary"
                                    class="lista-disciplinas">
                                      <v-layout row wrap align-center>
                                      <v-flex xs2>
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                              <span icon class="ma-2">
                                                <template v-if="disciplina.tipo_matriz === 'CPP' && contratoSelecionado.solicitarVagaCpp">
                                                  <v-icon color="red accent-2">warning</v-icon>
                                                </template>

                                                <template v-if="disciplina.tipo_matriz !== 'CPP' || (disciplina.tipo_matriz === 'CPP' && !contratoSelecionado.solicitarVagaCpp)">
                                                  <v-icon color="light-green accent-2">check_circle</v-icon>
                                                </template>
                                              </span>
                                            </template>
                                            <span>Detalhes da Disciplina</span>
                                          </v-tooltip>
                                        </v-flex>
                                        <v-flex xs8>
                                          {{disciplina.descricao}}
                                          <template v-if="disciplina.tipo_matriz === 'CPP' && contratoSelecionado.solicitarVagaCpp">
                                            <div style="font-weight: bold; color: red">
                                              * Solicite sua vaga com o coordenador
                                            </div>
                                          </template>
                                        </v-flex>
                                        <v-flex xs2>
                                          <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                              <v-btn icon v-on="on">
                                                <v-icon color="primary">info</v-icon>
                                              </v-btn>
                                            </template>
                                            <span>Detalhes da Disciplina</span>
                                          </v-tooltip>
                                        </v-flex>
                                      </v-layout>
                                    </div>

                                </template>
                                <template v-else>
                                  Curso com disciplinas ainda indisponíveis. Entre em contato com a Central de Atendimento para maiores informações.
                                </template>
                            </template>
                            <template v-else>
                              Nenhum contrato selecionado
                            </template>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex sm12 md6 lg6 v-if="temCPP()">
                <v-card flat color="grey lighten-3 ma-0 pa-0" >
                    <v-card-text class="pa-1">
                        <h4 class="title">Selecione a CPP que deseja cursar nesse módulo</h4>
                        <template v-if="contratoSelecionado&&contratoSelecionado.cpps.length">

                            <v-list two-line subheader>
                            <v-radio-group v-model="dadosMatricula.matricula.ref_disciplina_cpp"  class="radio-container d-flex">
                            <template v-for="(disciplina) in contratoSelecionado.cpps">
                              <v-list-tile @click="" style="width: 100%;">
                                <v-list-tile-action>
                                  <v-radio :key="disciplina.id" color="secondary" :value="disciplina.id">&nbsp;
                                  </v-radio>
                                </v-list-tile-action>

                                <v-list-tile-content @click="help(disciplina.descricao, disciplina.ementa, disciplina.turno)">
                                  <v-list-tile-title class="list-conteudo">
                                    {{ disciplina.descricao }}
                                  </v-list-tile-title>
                                  <v-list-tile-sub-title>{{ disciplina.turno }}</v-list-tile-sub-title>
                                  <v-list-tile-sub-title
                                  v-if="disciplina.turma_virtual == 'EAD'">
                                    <v-chip class="ml-0"
                                      color="blue"
                                      text-color="white"
                                      small
                                      >
                                        EAD
                                    </v-chip>
                                  </v-list-tile-sub-title>
                                  <v-list-tile-sub-title
                                  v-if="disciplina.turma_virtual == 'Virtual'">
                                    <v-chip class="ml-0"
                                      color="orange"
                                      text-color="white"
                                      small
                                      >
                                        100% Virtual
                                    </v-chip>
                                  </v-list-tile-sub-title>
                                </v-list-tile-content>

                                <v-list-tile-action @click="help(disciplina.descricao, disciplina.ementa, disciplina.turno)">
                                  <v-icon color="primary" @click.prevent.stop="help(disciplina.descricao, disciplina.ementa, disciplina.turno)">info</v-icon>
                                </v-list-tile-action>
                              </v-list-tile>
                              <v-divider></v-divider>
                            </template>
                            </v-radio-group>
                          </v-list>

                      </template>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <div class="flex-header">
            <navigation-buttons
              :show-previous="true"
              :show-next="true"
              :previous-click="voltar"
              :next-click="salvarDados"
              :disable-next="(($v.dadosMatricula.$invalid&&contratoSelecionado.cpps.length>0)||contratoSelecionado.solicitarVagaCpp)"
            >
            </navigation-buttons>
        </div>
    </v-container>
</template>
<style scoped lang="scss">
  .lista-disciplinas {
    cursor: pointer;
    margin-top: 15px;
    margin-bottom: 15px;
    color: #465e54 !important;
    border-left: 3px solid #465e54;
    background-color: #FFF;
  }
  .lista-disciplinas:hover {
    box-shadow: 1px 1px 3px 1px rgba(0,0,0,0.38);
  }
  .ementa {
    text-align: justify;
  }
  .list-conteudo {
    white-space: normal !important;
    width: 100%;
    height: 28px;
    font-size: 14px
  }
  .radio-container {
  .radio-item {
    border-bottom: 0.1rem #E5E5E5 solid;
    padding: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// DadosMatricula.vue?475c1e6c